<template>
    <th
        class="snapgrid-col"
        :class="{
            [theme.wrapper]: true,
            [theme.active]: isActive,
            [theme.hover]: showHoverClass,
            [theme.nowrap]: !col.wrap_column_text,
        }"
        :style="getStyle(col, 'col')"
        @mouseover="col.hover = true"
        @mouseout="col.hover = false"
        @click="click"
    >
        <span :class="theme.label">{{ col.label }}</span>
        <div v-show="showSortDesc" :class="[theme.sort, theme.desc]"></div>
        <div v-show="showSortAsc" :class="[theme.sort, theme.asc]"></div>
    </th>
</template>

<script>
import Common from './mixins/Common.vue';
import ProvidesStyles from './mixins/ProvidesStyles.vue';

export default {
    mixins: [Common, ProvidesStyles],
    props: {
        data: Object,
        col: Object,
    },
    computed: {
        isActive() {
            return this.isSortable && this.col.index === this.props.sort_col;
        },
        showHoverClass() {
            return this.isSortable && this.col.hover && !this.isActive;
        },
        showSortAsc() {
            return this.getVisibleSortIcon('asc');
        },
        showSortDesc() {
            return this.getVisibleSortIcon('desc');
        },
        isSortable() {
            if (!this.col.sortable) {
                return false;
            } else if (this.config.application_sort_enabled) {
                return true;
            } else if (this.config.sort_enabled && this.col.field) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        getVisibleSortIcon(dir) {
            if (!this.isSortable) {
                return false;
            } else if (this.isActive) {
                if (this.col.hover) {
                    return (
                        this.props.sort_dir === (dir === 'asc' ? 'desc' : 'asc')
                    );
                } else {
                    return (
                        this.props.sort_dir === (dir === 'asc' ? 'asc' : 'desc')
                    );
                }
            } else if (
                this.col.hover &&
                this.props.sort_dir === (dir === 'asc' ? 'asc' : 'desc')
            ) {
                return true;
            } else {
                return false;
            }
        },
        click() {
            if (this.isSortable) {
                this.$emit('col-selected', this.col.index);
            }
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/column.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/column.scss"
></style>
